
import Dropzone from "dropzone";
import Cropper from 'cropperjs'; 
import 'cropperjs/dist/cropper.css';
import noUiSlider from "nouislider";

export default {
  name: 'ImageResizer',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
          "@type": "Question",
          "name": "How can I resize a photo without losing image quality?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Photoshop is software that can easily resize images without losing quality. All you need to do is find an \"Image Size\" dialog box, change the width and height of the image, and set the desired image resolution."
          }
      },{
          "@type": "Question",
          "name": "How do I change the KB size of a photo?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "To resize KB images, you can use these online tools. Some tools support resizing multiple images based on the number of KB you want and downloading to get the resized image file."
          }
      },{
          "@type": "Question",
          "name": "What is the size of a 50kb photo?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "The pixel size for 50 KB ranges from 200 x 300 pixels to not reduce quality."
          }
      },{
          "@type": "Question",
          "name": "How much is 40 KB in pixels?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "40KB multiple images online usually have a resolution between 980x30 pixels. The above number may vary depending on the image format."
          }
      },{
          "@type": "Question",
          "name": "How do I calculate pixel file size?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "To calculate the pixels of an image file, multiply the dimensions together, combined with the bit depth. A 32-bit image measuring 2,048 x 3,072 will have a file size equal to (2048 x 3072 x 32) / 8 or 25,165,824 bytes."
          }
      }]
    };
  },
  head() {
    return {
        link: [
            { rel: 'stylesheet', href: '/assets/css/vendors.min.css' }
        ]
    }
  },
  data() {
    return {
        filesSelected: 0,
        local_image: null,
        format: 'jpg',
        progress: 0,
        loading: false,
        isActive: false,
        percentage: 0,
        imageWidth: 640,
        imageHeight: 427,
        imageWidthFinal: 640,
        imageHeightFinal: 427,
        form: this.$vform({ })
    };
  },
  mounted() {

        Dropzone.autoDiscover = false;

        let vm = this;

        var uploadedImageType = 'image/jpeg', uploadedImageName = 'image.jpg';

        var errors = false;

        var myDropzone = new Dropzone(".dropzone", { 
           maxFilesize: 5,
           autoProcessQueue: false,
           maxFiles:1,
           acceptedFiles: "image/*",
           previewsContainer: false,
           thumbnailWidth: null,
           thumbnailHeight: null,
           addedfile: function (file) {
                errors = false;
                if (this.files.length > 1) {
                    this.removeFile(this.files[0]);
                }
           },
           error: function (file, message) {
                this.removeFile(file);
                alert(message);
                errors = true;
           },
           thumbnail: function(file, dataUrl) {

                if(errors) return;

                if (/^image\/\w+/.test(file.type)) {
                    uploadedImageName = file.name;
                    uploadedImageType = file.type;                  
                }

                vm.imageWidth = file.width;
                vm.imageHeight = file.height;
                vm.onSetPercentage( vm.percentage );

                // start file reader
                let result = document.querySelector('#preview-image'), cropper = '';
                const reader = new FileReader();
                reader.onload = (e)=> {
                    // create new image
                    let img          = document.createElement('img');
                    img.id           = 'image';
                    img.className    = 'img-fluid';
                    img.src          = dataUrl;
                    result.innerHTML = '';
                    result.appendChild(img);
                    initCropper( uploadedImageName, uploadedImageType );
                };
                reader.readAsDataURL(file);
           }
        });

        initCropper( uploadedImageName, uploadedImageType );

        function initCropper( fileName, fileType ){

            // init cropper
            var cropper = window.Cropper;
            var URL     = window.URL || window.webkitURL;
            var image   = document.querySelector('#image');

            var options = {
                aspectRatio: 16 / 9,
                background: false,
                viewMode: 1
            };

            cropper = new Cropper(image, options);

            // Methods
            document.querySelector('.flip_clock_image').onclick = function(event) {

                var e      = event || window.event;
                var target = e.target || e.srcElement;
                var cropped;
                var result;
                var data;

                while (target !== this) {
                  if (target.getAttribute('data-method')) {
                    break;
                  }

                  target = target.parentNode;
                }

                data = {
                  method: target.getAttribute('data-method'),
                  option: target.getAttribute('data-option') || undefined
                };

                cropped = cropper.cropped;

                if (data.method) {

                  result = cropper[data.method](data.option);

                  switch (data.method) {

                    case 'scaleX':
                    case 'scaleY':
                        target.setAttribute('data-option', -data.option);
                      break;

                  }

                }
            };

            // Ratio toggles
            document.querySelector('.ratio-toggles').onchange = function(event) {
                var e      = event || window.event;
                var target = e.target || e.srcElement;

                if (!cropper) {
                  return;
                }

                options[target.name] = target.value;
                cropper.destroy();
                cropper = new Cropper(image, options);
            };

            // Resize Image
            document.querySelector('.resize_image').onclick = function(event) {

                var e      = event || window.event;
                var target = e.target || e.srcElement;
                var cropped;
                var result;
                var data;

                while (target !== this) {
                  if (target.getAttribute('data-method')) {
                    break;
                  }

                  target = target.parentNode;
                }

                data = {
                  method: target.getAttribute('data-method'),
                  option: target.getAttribute('data-option') || undefined
                };

                data.option = JSON.parse(data.option);

                cropped = cropper.cropped;

                if (data.method) {

                  result = cropper[data.method](data.option);

                  switch (data.method) {

                    case 'getCroppedCanvas':
                        
                        if (result) {
                            vm.onSetImageData( result.toDataURL(uploadedImageType) );
                        }

                      break;

                  }

                }
            };
            
        }

        /**
         * -------------------------------------------------------------------------------
         *  noUiSlider
         * -------------------------------------------------------------------------------
        **/
        var slider = document.getElementById('slider');

        noUiSlider.create(slider, {
            start: [0],
            connect: true,
            step: 1,
            range: {
                'min': 100,
                'max': 500
            },
            format: wNumb({
                decimals: 0
            })
        });

        slider.noUiSlider.on('update', function (values, handle) {
            vm.onSetPercentage( values[handle] );
        });
  },
  methods: {
    onConvertType: function() {
      this.isActive = !this.isActive;
    },
    handleFileChange(event) {
        this.progress      = 0;
        this.filesSelected = event.target.files.length;
        this.local_image   = event.target.files[0];
    },
    onImageResizer() {

        this.progress = 0;

        const config = {
          onUploadProgress: (progressEvent) => this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        };

        const data = new FormData();

        data.append('local_image', this.local_image);
        data.append('width', this.imageWidthFinal);
        data.append('height', this.imageHeightFinal);
        data.append('format', this.format);

        this.loading = true;

        this.$axios.post(`/tool/image-resizer`, data, config, { headers: { 'Content-Type': 'multipart/form-data', 'Accept': 'multipart/form-data' } }).then(res => {
           
            jQuery('.download-image').attr( 'href',  res.data.download );

            jQuery('.preview-download-image').attr('src', res.data.preview);

            jQuery('#modalPreviewDownloadImage').modal('show');

        }).catch(e => {

          this.form.errors.set(e.response.data.errors);

        }).finally(() => {

          this.loading = false

       });

    },
    onSetImageData( imageData ){
        this.local_image = imageData;
    },
    onSetPercentage( value ){
        this.percentage       = Math.floor(value);
        this.imageWidthFinal  = Math.floor( this.imageWidth * value / 100 );
        this.imageHeightFinal = Math.floor( this.imageHeight * value / 100 );
    },
    onDownloadImage( image ) {
        const link   = document.createElement('a');
        var filename = image.srcElement.dataset.filename;
        link.href    = image.srcElement.href;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }
    //
  }
}
